(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lm-race-fuel-station"] && !Shopify.designMode) return;
  try {
    
function initFuelChoice(scope) {
  scope.querySelectorAll('[data-lm-choice]').forEach(choice => {
    if (choice.dataset.ready) return;
    choice.dataset.ready = 'true';
    const mobile = window.matchMedia('(max-width: 999px)');
    choice.open = !mobile.matches;
    mobile.addEventListener('change', () => { choice.open = !mobile.matches; });
    const root = choice.closest('[data-lm-fuel-station]');
    root.addEventListener('click', event => {
      if (event.target.closest('[data-lm-pickup-quick]')) choice.open = true;
      const fuel = event.target.closest('.lm-fuel-code');
      if (!fuel || !mobile.matches) return;
      choice.open = false;
      choice.querySelector('summary').focus({ preventScroll: true });
      root.querySelector('.lm-fuel-station__station').scrollIntoView({block: 'start', behavior: 'auto'});
    });
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initFuelChoice(document));
else initFuelChoice(document);
document.addEventListener('shopify:section:load', event => initFuelChoice(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mototec-parts-finder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-mototec-finder]');
    const sources = [...(root?.querySelectorAll('[data-mototec-parts-index]') || [])];
    if (!root || !sources.length) return;
    const modelSelect = root.querySelector('[data-mototec-model-select]');
    const categorySelect = root.querySelector('[data-mototec-category-select]');
    const searchInput = root.querySelector('[data-mototec-search]');
    const grid = root.querySelector('[data-mototec-parts-grid]');
    const count = root.querySelector('[data-mototec-result-count]');
    const empty = root.querySelector('[data-mototec-empty]');
    const moreWrap = root.querySelector('[data-mototec-more-wrap]');
    const moreButton = root.querySelector('[data-mototec-show-more]');
    const shards = sources.map(source => JSON.parse(source.textContent));
    const data = { models: shards[0].models, categories: shards[0].categories, items: shards.flatMap(shard => shard.items) };
    const categoryGroups = [['batteries-chargers', 'Batteries & Chargers', ['BATTERY / CHARGING']], ['brakes', 'Brake Parts', ['BRAKES']], ['electrical', 'Electrical Parts', ['ELECTRICAL', 'LIGHTING']], ['wheels-tires', 'Wheels & Tires', ['WHEELS / TIRES']], ['drivetrain-engine', 'Drivetrain & Engine Parts', ['DRIVETRAIN', 'ENGINE']], ['body-controls-hardware', 'Body, Controls & Hardware', ['CONTROLS', 'FRAME / BODY', 'HANDLEBAR / STEERING', 'HARDWARE', 'OTHER', 'Other Replacement Parts', 'SEAT', 'SUSPENSION']]];
    const categoryByRaw = new Map(categoryGroups.flatMap(group => group[2].map(raw => [raw, group])));
    data.models.forEach(model => modelSelect.add(new Option(model, model)));
    categoryGroups.forEach(group => categorySelect.add(new Option(group[1], group[0])));
    const items = data.items.map(item => ({ title: item[0], handle: item[1], sku: item[2], price: item[3], available: Boolean(item[4]), image: item[5], models: item[6], category: categoryByRaw.get(data.categories[item[7]]) || categoryGroups[5] }));
    const money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: 'USD' });
    let limit = 24;
    let filtered = [];
    const card = item => {
      const article = document.createElement('article'); article.className = 'mototec-finder__card';
      const imageLink = document.createElement('a'); imageLink.className = 'mototec-finder__image'; imageLink.href = `/products/${item.handle}`;
      if (item.image) { const image = document.createElement('img'); image.src = item.image; image.alt = item.title; image.loading = 'lazy'; image.decoding = 'async'; imageLink.append(image); }
      const body = document.createElement('div'); body.className = 'mototec-finder__card-body';
      const sku = document.createElement('p'); sku.className = 'mototec-finder__sku'; sku.textContent = item.sku;
      const heading = document.createElement('h2'); const titleLink = document.createElement('a'); titleLink.href = imageLink.href; titleLink.textContent = item.title; heading.append(titleLink);
      const category = document.createElement('p'); category.className = 'mototec-finder__category'; category.textContent = item.category[1];
      const availability = document.createElement('p'); availability.className = 'mototec-finder__availability'; availability.textContent = item.available ? root.dataset.inStockLabel : root.dataset.outStockLabel;
      const price = document.createElement('p'); price.className = 'mototec-finder__price'; price.textContent = money.format(Number(item.price));
      const action = document.createElement('a'); action.className = 'mototec-finder__button'; action.href = imageLink.href; action.textContent = root.dataset.viewPartLabel;
      body.append(sku, heading, category, availability, price, action); article.append(imageLink, body); return article;
    };
    const updateUrl = () => { const url = new URL(window.location.href); [['model', modelSelect.value], ['category', categorySelect.value], ['q', searchInput.value.trim()]].forEach(([key, value]) => value ? url.searchParams.set(key, value) : url.searchParams.delete(key)); history.replaceState({}, '', url); };
    const render = reset => {
      const started = performance.now(); if (reset) limit = 24;
      const modelIndex = data.models.indexOf(modelSelect.value); const query = searchInput.value.trim().toLocaleLowerCase();
      filtered = items.filter(item => (modelIndex < 0 || item.models.includes(modelIndex)) && (!categorySelect.value || item.category[0] === categorySelect.value) && (!query || `${item.title} ${item.sku} ${item.category[1]}`.toLocaleLowerCase().includes(query)));
      grid.replaceChildren(...filtered.slice(0, limit).map(card)); count.textContent = `${filtered.length} ${filtered.length === 1 ? root.dataset.oneLabel : root.dataset.manyLabel}`; empty.hidden = filtered.length > 0; moreWrap.hidden = filtered.length <= limit; root.dataset.lastFilterMs = (performance.now() - started).toFixed(1); updateUrl();
    };
    const params = new URL(window.location.href).searchParams; const requestedModel = params.get('model'); const requestedCategory = params.get('category');
    if (requestedModel && data.models.includes(requestedModel)) modelSelect.value = requestedModel;
    if (requestedCategory && categoryGroups.some(group => group[0] === requestedCategory)) categorySelect.value = requestedCategory;
    searchInput.value = params.get('q') || '';
    [modelSelect, categorySelect].forEach(control => control.addEventListener('change', () => render(true))); searchInput.addEventListener('input', () => render(true)); moreButton.addEventListener('click', () => { limit += 24; render(false); }); render(true);
  })();

  } catch(e) { console.error(e); }
})();
})();
